import { HttpError } from "./http-error";

export class HttpResponseError extends HttpError {

    readonly code: number;
    readonly name: string;

    /**
     *
     * @param {Response} response
     */
    constructor(message: string, response: Response) {
        super(HttpResponseError.buildMessage(message, response));
        this.code = response.status;
        this.name = "HttpResponseError";
    }

    static buildMessage(message : string, response: Response) : string {
        if(message) {
            return `HTTP Error: ${message}: ${response.status} ${response.statusText}`;
        } else {
            return `HTTP Error: ${response.status} ${response.statusText}`;
        }
    }
}